<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  props: {
    retiredConfirmation: {
      type: Boolean,
    },
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    const retiredTips = [
      'The Review Retire/Merge ID Details panel displays the "Retired ID" and the "ID Retained/Merged Into" along with all data fields. The “ID Retained/Merged Into” is now the master record.',
      'The retirement action has been finalized and cannot be reverted.',
    ];
    const activeTips = [
      'This compare page displays the ID to be Retired and the ID to Merge To side-by-side to enable verification of the retirement. Verify all data before submitting a retirement request, as retirements are final and cannot be reverted.',
      'The record on the left in the “ID TO BE RETIRED” section displays the identifier that will be retired, while the “ID TO BE RETAINED / MERGED INTO” displays the identifier to be merged into if a record was selected to merge into. These records can be switched/ flipped if needed by clicking the “Switch Records” link between the two records.',
      'For Queue search, A “ID TO BE RETAINED / MERGED INTO” record can be removed from the page by clicking the “Not a Duplicate (Remove from List)” link button. This does not delete the record or impact the Master record or retired identifier. This action only removes the potential duplicate from the queue/page.',
      'The identifier to be retired can be retired without merging to another identifier by clicking the Retire ID with No Merge. This will retire the record and the Master record and all history records will be retired. This cannot be reverted. The identifier to be retired can be merged into another record by clicking the Retire ID and Merge Records button. When this option is used, the Master record and the history records for the identifier to be retired will be merged into the ID to be Merged To. The retired identifier cannot be unretired for any reason.',
    ];
    this.tips = [
      {
        body: this.retiredConfirmation ? retiredTips : activeTips,
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
